import { Controller } from '@hotwired/stimulus';

/*
 * Header controller
 *
 * Felelős a két soros fejléc viselkedéséért:
 *  - Lefelé görgetéskor a felső sáv (logó + elérhetőségek) kompakttá zsugorodik
 *    a `.scrolldown` osztállyal, a menüsáv viszont a tetőn tapadva marad.
 *  - Folyamatosan közzéteszi a fejléc aktuális magasságát a `--header-h`
 *    CSS változóban, így az offcanvas menü mindig pontosan a fejléc alatt nyílik.
 */
export default class extends Controller {
    connect() {
        this.lastScrollTop = window.scrollY;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.publishHeight = this.publishHeight.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.publishHeight, { passive: true });

        // A zsugorodás 350ms-es átmenet, ennek végén frissítjük a magasságot.
        this.headerRow = this.element.querySelector('#header-row');
        if (this.headerRow) {
            this.headerRow.addEventListener('transitionend', this.publishHeight);
        }

        this.publishHeight();
    }

    disconnect() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.publishHeight);
        if (this.headerRow) {
            this.headerRow.removeEventListener('transitionend', this.publishHeight);
        }
    }

    onScroll() {
        if (this.ticking) {
            return;
        }
        this.ticking = true;
        window.requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
        });
    }

    handleScroll() {
        const y = window.scrollY;

        if (y > this.lastScrollTop && y > 120) {
            // Ne húzzuk össze a fejlécet, amíg egy asztali almenü nyitva van.
            if (!this.element.querySelector('.submenu-lvl1.active')) {
                this.element.classList.add('scrolldown');
            }
        } else if (y < this.lastScrollTop) {
            this.element.classList.remove('scrolldown');
        }

        this.lastScrollTop = y;
        // A --header-h-t NEM olvassuk ki minden görgetéskor (forced reflow lenne):
        // a fejléc magassága csak a kompakttá váláskor változik, azt a header-row
        // transitionend eseménye frissíti (lásd connect()).
    }

    publishHeight() {
        document.documentElement.style.setProperty('--header-h', `${this.element.offsetHeight}px`);
    }
}
